import { Routes, Route } from "react-router-dom";
import PrivateAuth from '../../authorization/PrivateAuth';
import Icons from "../../../pages/Dev/Icons";
import ButtonShowcase from "../../../pages/Dev/Button";
function DevRoute() {
    return (
        <Routes>
           <Route element={<PrivateAuth />}>
                <Route path="icons" element={<Icons />} />
                <Route path="button" element={<ButtonShowcase />} />
           </Route>
        </Routes>
    );
}

export default DevRoute;
